// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AiCredits_PurchaseStatusResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Purchase status response — returned by GET /ai/credits/purchase/{id}/status.
 *
 * Returns the current state of a purchase row so the frontend can poll
 * until status transitions from 'pending' to 'confirmed' | 'failed' | 'expired'
 * (C, 2026-08-06 — abandoned-purchase sweep). 'expired' is a bookkeeping
 * close, not a permanent terminal state: a late webhook can still transition
 * an expired row to 'confirmed' or 'failed' (Ai_credit_purchase_model's
 * widened CAS).
 *
 * credits_granted is null until the purchase is confirmed.
 * currency is the ISO 4217 code resolved at purchase time (B3 — multi-currency).
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface AiCredits_PurchaseStatusResponseDados {
purchase_id: number
franquia_id: number
pack_id: number
charge_id: string
status: string
request_id: string
currency: string
credits_granted?: number
}

export type AiCredits_PurchaseStatusResponse = ApiResponse<AiCredits_PurchaseStatusResponseDados>;

registerResponseContract('AiCredits_PurchaseStatusResponse', {
  purchase_id:     { type: 'number',  required: true },
  franquia_id:     { type: 'number',  required: true },
  pack_id:         { type: 'number',  required: true },
  charge_id:       { type: 'string',  required: true },
  status:          { type: 'string',  required: true },
  request_id:      { type: 'string',  required: true },
  currency:        { type: 'string',  required: true },
  credits_granted: { type: 'number',  required: false },
})
